/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import 'classlist.js';
import 'web-animations-js';
import 'whatwg-fetch';
import 'zone.js';

import 'abortcontroller-polyfill';
import 'es7-object-polyfill';

import 'core-js/es/array';
